import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AuthProvider } from './contexts/AuthContext'
import { PrescriptionProvider } from './contexts/PrescriptionContext'
import { SubscriptionProvider } from './contexts/SubscriptionContext'
import ToastProvider from './components/base/ToastProvider'
import TutorialProvider from './tutorial/TutorialProvider'
import { PlanComplianceGate } from './components/payment/PlanComplianceGate'


function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL || '/'}>
      <AuthProvider>
        <SubscriptionProvider>
          <PrescriptionProvider>
            <TutorialProvider>
              <PlanComplianceGate>
                <AppRoutes />
              </PlanComplianceGate>
              <ToastProvider />
            </TutorialProvider>
          </PrescriptionProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
